

import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined';
export const settingsWarehouseOutboundStockConfig = {
    standard:  {
        title: "standard_carriers",
        icon: <LocalShippingOutlined/>,
    },
};
